<template>
    <v-select-with-validation v-bind="$attrs" v-on="$listeners" :items="entityOptions" :label="label" :value="value"
        @input="updateValue" />
</template>

<script lang="ts">
import Vue from "vue";
import VSelectWithValidation from "./VSelectWithValidation.vue";
import { UserTaxEntityTypeEnum } from "@/service";
export default Vue.extend({
    components: {
        VSelectWithValidation
    },
    props: {
        label: {
            type: String,
            default: "Entity Type"
        },
        value: {
            type: String,
            default: null
        }
    },
  computed: {
    entityOptions(): Array<{ value: string; text: string }> {
      return Object.values(UserTaxEntityTypeEnum).map((value) => ({
        value: String(value),
        text: String(value)
      }));
    }
  },
    methods: {
        updateValue(selectedValue: string) {
            this.$emit("input", selectedValue);
        }
    }
});
</script>